import { styled } from '@mui/material'
import { Link } from 'react-router-dom'

export const TableLink = styled(Link)(() => ({
  all: 'unset',
  padding: '4px 8px',
  height: '100%',
  display: 'block',
}))
